import React, { useState } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import { connect } from "react-redux";
import PropTypes from "prop-types";

const GET_BLOCKED_USERS = gql`
  query AllBlockedUsers($token: String!) {
    allBlockedUsers(
      input: {
        token: $token,
        first: 100,
        page: 1,
      }) {
      data {
        display_name
        uuid
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;

const UNBLOCK_USER = gql`
  mutation UnblockUser($token: String!, $uuid: String!) {
    unblockUser(input: {token: $token, uuid: $uuid}) {
      status
      message
    }
  }
`;

function BlockSection({ token }) {
  const [blockMessage, setBlockMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [unblockUser] = useMutation(UNBLOCK_USER, {
    onCompleted: (d) => {
      setBlockMessage(d.unblockUser.message);
    },
    onError: () => {
      setErrorMessage('There was an error when trying to unblock that user.');
    },
    refetchQueries: [GET_BLOCKED_USERS],
  });
  const { error, data } = useQuery(GET_BLOCKED_USERS, {
    variables: { token },
  });

  // if (loading) return <p>Loading...</p>;
  if (error) return null;

  const hasBlockedUsers = data?.allBlockedUsers?.data?.length || -1 > 0;
  return (
    <div>
      <div>
        <h2 className="py-3">Blocked Users</h2>
      </div>
      <div>
        {blockMessage && (
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            <strong>Success!</strong> {blockMessage}
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => setBlockMessage(null)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}
        {errorMessage && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>Something went wrong!</strong> {errorMessage}
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => setErrorMessage(null)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}
      </div>
      {!hasBlockedUsers ? (
        <div> No blocked users</div>
      ) : (
        <table className="table table-sm">
          {data?.allBlockedUsers?.data?.map(({ uuid, display_name: displayName }) => {
            return (
              <tr key={uuid}>
                <td>{displayName}</td>
                <td className="text-right">
                  <button
                    className="btn btn-sm btn-info"
                    onClick={() => unblockUser({ variables: { token, uuid } })}
                  >
                    Unblock
                  </button>
                </td>
              </tr>
            );
          })}
        </table>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.commentToken,
  };
};

BlockSection.propTypes = {
  token: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(BlockSection);
